// extracted by mini-css-extract-plugin
export default {"button":"jz9NT9L4F47kGi4SxDLE","invert":"lQnjkLSqJiGZZCx6KNMj","large":"AflLbTHodzKsuzCpkxb5"};